var exports = {
  "k": "xdde3148b--f97a70--container",
};

module.exports = exports;
